<app-loader *ngIf="isDisabled"></app-loader>
<div class="card" style="min-height: 100%;">
    <div class="card-header">
        Profile Details
    </div>
    <div class="card-body p-0" style="overflow: auto;">
        <div *ngIf="InputData.OperationType === 'PermanentAddress'">
            <!-- <div class="card-body" style="overflow: auto;"> -->
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th style="display: none;">Name</th>
                            <th>NativeAddress1</th>
                            <th>NativeAddress2</th>
                            <th>Village City</th>
                            <th>State Name</th>
                            <th>District Name</th>
                            <th>Taluka Name</th>
                            <th>Pincode</th>
                            <th style="display: none;">Approval Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let site of TableDatas; let i = index">
                            <td style="display: none;">{{ site['FullName'] }}</td>
                            <td>{{site['NativeAddress1']}}</td>
                            <td>{{site['NativeAddress2']}}</td>
                            <td>{{site['VillageCity']}}</td>
                            <td>{{site['StateName']}}</td>
                            <td>{{site['DistrictName']}}</td>
                            <td>{{site['TalukaName']}}</td>
                            <td>{{site['Pincode']}}</td>
                            <td style="display: none;">{{site['ApprovalStatus']}}</td>
                        </tr>
                    </tbody>
                </table>
            <!-- </div> -->
        </div>
        <div *ngIf="InputData.OperationType === 'CurrentAddress'">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="display: none;">Name</th>
                        <th>LocalAddress1</th>
                        <th>LocalAddress2</th>
                        <th>Village City</th>
                        <th>State Name</th>
                        <th>District Name</th>
                        <th>Taluka Name</th>
                        <th>Pincode</th>
                        <th style="display: none;">Approval Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of TableDatas; let i = index">
                        <td style="display: none;">{{ site['FullName'] }}</td>
                        <td>{{site['LocalAddress1']}}</td>
                        <td>{{site['LocalAddress2']}}</td>
                        <td>{{site['VillageCity']}}</td>
                        <td>{{site['StateName']}}</td>
                        <td>{{site['DistrictName']}}</td>
                        <td>{{site['TalukaName']}}</td>
                        <td>{{site['Pincode']}}</td>
                        <td style="display: none;">{{site['ApprovalStatus']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div *ngIf="InputData.OperationType === 'Details'">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th>First Name</th>
                        <th>Middle Name</th>
                        <th>Last Name</th>
                        <th>Gender Name</th>
                        <th>Birth Date</th>
                        <th>Father/Husband Name</th>
                        <th>Martial Status Name</th>
                        <th style="display: none;">Approval Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of TableDatas; let i = index">
                        <td>{{ site['FirstName'] }}</td>
                        <td>{{site['MiddleName']}}</td>
                        <td>{{site['LastName']}}</td>
                        <td>{{site['GenderName']}}</td>
                        <td>{{site['BirthDate']}}</td>
                        <td>{{site['FatherHusbANDName']}}</td>
                        <td>{{site['MartialStatusName']}}</td>
                        <td style="display: none;">{{site['ApprovalStatus']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div *ngIf="InputData.OperationType === 'Qualification'">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="display: none;">Name</th>
                        <th>Qualification Name</th>
                        <th>University Board</th>
                        <th>Year Of Passing</th>
                        <th>Percentage</th>
                        <th>Grade Class</th>
                        <th style="display: none;">Approval Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of TableDatas; let i = index">
                        <td style="display: none;">{{ site['FullName'] }}</td>
                        <td>{{site['QualificationName']}}</td>
                        <td>{{site['UniversityBoard']}}</td>
                        <td>{{site['YearOfPassing']}}</td>
                        <td>{{site['Percentage']}}</td>
                        <td>{{site['GradeClass']}}</td>
                        <td style="display: none;">{{site['ApprovalStatus']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div *ngIf="InputData.OperationType === 'Bank'">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered" name="newbank">
                <thead class="table-light">
                    <tr>
                        <th style="display: none;">Name</th>
                        <th>Payment Mode Name</th>
                        <th>Bank Name</th>
                        <th>Bank Branch Name</th>
                        <th>IFSCode</th>
                        <th>Bank Account No</th>     
                        <th style="display: none;">Approval Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of TableDatas; let i = index">
                        <td style="display: none;">{{ site['FullName'] }}</td>
                        <td>{{site['PaymentModeName']}}</td>
                        <td>{{site['BankName']}}</td>
                        <td>{{site['BankBranchName']}}</td>
                        <td>{{site['IFSCode']}}</td>
                        <td>{{site['BankAccountNo']}}</td>   
                        <td style="display: none;">{{site['ApprovalStatus']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div *ngIf="InputData.OperationType === 'Document'">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="display: none;">Name</th>
                        <th>Document Name</th>
                        <th style="display: none;">Document Folder Name</th>
                        <th>Document Number</th>
                        <th>File Name</th>
                        <th style="display: none;">Approval Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of TableDatas; let i = index">
                        <td style="display: none;">{{ site['FullName'] }}</td>
                        <td>{{site['DocumentName']}}</td>
                        <td style="display: none;">{{site['DocumentFolderName']}}</td>
                        <td>{{site['DocumentNumber']}}</td>
                        <td> 
                            <a [href]="site['FileLink']" target="_blank">{{ site['FileName'] }}</a>
                        </td>
                        <td style="display: none;">{{site['ApprovalStatus']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div *ngIf="InputData.OperationType === 'Nominee'">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="display: none;">Full Name</th>
                        <th>Name</th>
                        <th>Address1</th>
                        <th>Address2</th>
                        <th>Relationship Name</th>
                        <th>Village City</th>
                        <th>State Name</th>
                        <th>District Name</th>
                        <th>Taluka Name</th>
                        <th>Pincode</th>
                        <th>Birth Date</th>
                        <th>Share</th>
                        <th>Guardian</th>
                        <th style="display: none;">Approval Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of TableDatas; let i = index">
                        <td style="display: none;">{{site['FullName'] }}</td>
                        <td>{{site['Name']}}</td>
                        <td>{{site['Address1']}}</td>
                        <td>{{site['Address2']}}</td>
                        <td>{{site['RelationshipName']}}</td>
                        <td>{{site['VillageCity']}}</td>
                        <td>{{site['StateName'] }}</td>
                        <td>{{site['DistrictName']}}</td>
                        <td>{{site['TalukaName']}}</td>
                        <td>{{site['Pincode']}}</td>
                        <td>{{site['BirthDate']}}</td>
                        <td>{{site['Share']}}</td>
                        <td>{{site['Guardian']}}</td>
                        <td style="display: none;">{{site['ApprovalStatus']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div *ngIf="InputData.OperationType === 'Dependent'">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="display: none;">Full Name</th>
                        <th>Name</th>
                        <th>Address Type Name</th>
                        <th>Relationship Name</th>
                        <th>Date Of Birth</th>
                        <th style="display: none;">Approval Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of TableDatas; let i = index">
                        <td style="display: none;">{{site['FullName'] }}</td>
                        <td>{{site['Name']}}</td>
                        <td>{{site['AddressTypeName']}}</td>
                        <td>{{site['RelationshipName']}}</td>
                        <td>{{site['DateOfBirth']}}</td>
                        <td style="display: none;">{{site['ApprovalStatus']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end notification-action">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="Cancel()"><i class="bi bi-x"
                    *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Cancel':'Loading...'}}</button>
        </div>
    </div>
</div>